import React, { Component } from 'react'
import { Card, withStyles, CardHeader, Typography, Avatar, CardContent, InputBase, IconButton, Divider } from '@material-ui/core';
import Assessment from '@material-ui/icons/Assessment'
import Search from '@material-ui/icons/Search'
import AttendanceReportSingle from './AttendanceReportSingle';
import { GetData } from '../../api/service';

const styles = theme => ({
    cardBody: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },
})

class AttendanceReportLanding extends Component {

    constructor(props) {
        super(props);

        this.state = {
            roll_no: '',
            table_data: [],
            isLoading: true
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onSubmit = (e) => {
        e.preventDefault();

        GetData(`/${this.props.apikey}/${this.props.username}/${this.state.roll_no}/getstudentreportsingle`)
        .then((resp) => {
            if(resp !== false){
                this.setState({
                    table_data: resp,
                    isLoading: false
                })
            }else{
                this.setState({
                    isLoading: false,
                    table_data: []
                })
            }
        })
    }

    render() {
        let { classes } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader
                        avatar={
                            <Avatar>
                                <Assessment />
                            </Avatar>
                        }
                        title={
                            <Typography
                                variant="h5"
                            >
                                Attendance Report
                    </Typography>
                        }
                        subheader={`Search students here`}
                    />
                    <form onSubmit={this.onSubmit}>
                        <CardContent className={classes.cardBody}>

                            <IconButton>
                                <Assessment />
                            </IconButton>

                            <InputBase
                                name="roll_no"
                                value={this.state.roll_no}
                                onChange={this.onChange}
                                required={true}
                                placeholder="Search by Roll No" />

                            <Divider className={classes.divider} />

                            <IconButton type="submit">
                                <Search />
                            </IconButton>
                        </CardContent>
                    </form>
                </Card>

                <br />

                {this.state.isLoading ? null : 
                <AttendanceReportSingle
                    {...this.state.table_data}
                />}
            </div>
        )
    }
}

export default withStyles(styles)(AttendanceReportLanding)